export async function fetchShopifyCollectionProducts(handle, pageSize, endCursor) {
  const after = endCursor ? `, after: "${endCursor}"` : '';
  const query = `
    {
      collection(handle: "${handle}") {
        products(first: ${pageSize}${after}) {
          pageInfo {
            hasNextPage
            endCursor
          }
          nodes {
            id
            title
            handle
            availableForSale
            variants(first: 1) {
              nodes {
                id
                price {
                  amount
                  currencyCode
                }
              }
            }
            featuredImage {
              url(transform: {maxWidth: 600})
            }
          }
        }
      }
    }
  `;
  const res = await fetch('https://delilah-nottingham.myshopify.com/api/2025-07/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': '74c22522dd309d663f734ee74e47ce04'
    },
    body: JSON.stringify({ query })
  });
  return res.json();
}

export function renderProductCard(product, selectedProductMap) {
  const variantId = product.variants.nodes[0].id;
  const match = variantId.match(/(\d+)$/);
  const variantLegacyId = match ? parseInt(match[1], 10) : null;
  const existingQuantity = selectedProductMap.get(variantLegacyId)?.quantity || 0;
  const imageSrc = product.featuredImage?.url || '//z6xnar4zmxdvjhl8-5510332504.shopifypreview.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_600x600.gif';
  const minusDisabled = existingQuantity === 0 ? 'disabled' : '';
  return `
      <div class="product-card">
        <div class="product-data">
          <img src="${imageSrc}" alt="${product.title}" />
          <div class="spacing-style text-block custom
    text-block--align-center custom-typography  custom-font-size  custom-color collection-product-title
  ">
          <p class="">${product.title}</p>
        </div>
        <div class="text-block text-block--align-center custom-typography custom-font-size custom-color text-center custom spacing-style collection-product-price" style="">
          <p class="price">&pound;${product.variants.nodes[0].price.amount}</p>
        </div>
        </div>
        <div class="product-actions">
            <quantity-selector-component
              class="quantity-selector byo-quantity-selector"
              ref="quantitySelectors[]"
            >
              <button
                class="button button-secondary color-scheme-2"
                type="button"
                name="minus"
                on:click="/decreaseQuantity"
                ref="quantityButtons[]"
                data-variant-id="${variantLegacyId}"
                ${minusDisabled}
              >
                <span class="svg-wrapper icon-plus">
                  -
                </span>
              </button>
              <input
                class="byo-quantity-input"
                type="number"
                name="quantity"
                value="${existingQuantity}"
                min="0"
                ref="quantityInput"
                step="1"
                data-variant-id="${variantLegacyId}"
                data-price="${product.variants.nodes[0].price.amount}"
                readonly
              >
              <button
                class="button button-secondary color-scheme-2"
                type="button"
                name="plus"
                on:click="/increaseQuantity"
                ref="quantityButtons[]"
                data-variant-id="${variantLegacyId}"
              >
                <span class="svg-wrapper icon-plus">
                  +
                </span>
              </button>
            </quantity-selector-component>
        </div>
      </div>
    `;
}
